import { render, staticRenderFns } from "./CategoryFacetCard.vue?vue&type=template&id=1f657380"
import script from "./CategoryFacetCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryFacetCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports